<template>
    <WhiteIQOS bodyClass="gap-row-xs" noOverflow>
        <div class="gap-column-sm cost-header">
            <div class="gap-row-1xs w-100">
                <div class="qrw-heading-xs bold qrw-text-content-base-primary">
                    {{ $t('delivery_tariffs.title') }}
                </div>
                <div class="qrw-paragraph-md qrw-text-content-base-secondary">
                    {{ $t('delivery_tariffs.subtitle') }}
                </div>
            </div>
            <div class="tabs-container">
                <BaseTabSwitcher v-model="cost_type" class="w-100" size="sm" :tabs="[
                    {
                        text: $t('delivery_tariffs.type_free'),
                        value: 'free',
                    },
                    {
                        text: $t('delivery_tariffs.type_paid'),
                        value: 'tariffed',
                    }
                ]" />
            </div>

        </div>
        <BaseDivider color="border-base-tertiary" v-if="cost_type !== 'free'" />
        <template v-if="cost_type === 'tariffed'">
            <div class="gap-column-sm cost-header">
                <div class="qrw-heading-xs bold qrw-text-content-base-primary w-100">
                    {{ $t('delivery_tariffs.mode_title') }}
                </div>
                <BaseTabSwitcher v-model="tariffication_mode" class="w-100" size="sm" :tabs="[
                    {
                        text: $t('delivery_tariffs.mode_custom'),
                        value: 'custom',
                    },
                    {
                        text: $t('delivery_tariffs.mode_partner'),
                        value: 'partner',
                    }
                ]" />
            </div>
            <template v-if="tariffication_mode === 'custom'">
                <div class="tariff-card" v-for="(item, index) in tariffs" :key="index">
                    <div class="gap-column-1xs cost-header">
                        <div class="qrw-label-lg bold qrw-text-content-base-primary w-100">
                            {{ $t('delivery_tariffs.tariff') }} {{ index + 1 }}
                        </div>
                        <BaseIconButton textColor="content-error-primary" variant="ghost" size="sm" icon="trash"
                            @click="removeTariff(index)">

                        </BaseIconButton>
                    </div>

                    <div class="card-row">
                        <div class="card-label">{{ $t('delivery_tariffs.prop_name') }}</div>
                        <BaseTextInput @blur="save" :placeholder="$t('delivery_tariffs.name_ph')" v-model="item.name"
                            size="md" />
                    </div>
                    <div class="card-row">
                        <div class="card-label">{{ $t('delivery_tariffs.prop_price') }}</div>
                        <BaseUnitInput @blur="save" fullWidth type="number" unitPlaceholder="$" placeholder="0"
                            v-model.number="item.price" size="md" />
                    </div>
                    <div class="card-row">
                        <div class="card-label">{{ $t('delivery_tariffs.prop_zone') }}</div>
                        <BaseBetaSelect size="md" :value="item.zone" @input="v => setTariffZone(item, v)" class="w-100"
                            :choices="availableZones" />
                    </div>
                </div>
                <BasePushButton @click="addNewTariff" variant="primary" bgColor="background-base-secondary" size="sm"
                    icon="plus">
                    {{ $t('delivery_tariffs.btn_add') }}
                </BasePushButton>
            </template>

        </template>
    </WhiteIQOS>
</template>

<script>
export default {
    data () {
        return {
            ready: false,
            cost_type: 'free',
            tariffication_mode: 'custom',
            tariffs: []
        }
    },
    watch: {
        cost_type () {
            this.save();
        },
        tariffication_mode () {
            this.save();
        }
    },
    methods: {
        setTariffZone (tariff, zoneValue) {
            const index = this.tariffs.indexOf(tariff);
            this.$set(this.tariffs, index, { ...tariff, zone: zoneValue });
            this.save();
        },
        removeTariff (idx) {
            this.tariffs.splice(idx, 1);
            this.save();
        },
        save () {
            if (!this.ready) return
            this.$store.commit('setDeliveryTypeAndTarifffs', {
                cost_type: this.cost_type,
                tariffication_mode: this.tariffication_mode,
                tariffs: this.tariffs
            });
            this.$store.dispatch('saveCafe');
        },
        reset () {
            this.cost_type = this.cafe.delivery.cost_type;
            this.tariffication_mode = this.cafe.delivery.tariffication_mode;
            this.tariffs = this.cafe.delivery.tariffs;
        },
        addNewTariff () {
            this.tariffs.push({ name: '', price: 0, zone: null });
        }
    },
    mounted () {
        this.reset();
        this.ready = true;
    },
    computed: {
        cafe () {
            return this.$store.state.cafe;
        },
        availableZones () {
            return this.cafe.delivery.geolocations.filter(g => g._id).reduce(
                (acc, g, index) => {
                    acc[g._id] = g.name || `${index + 1}`;
                    return acc;
                }, {}
            );
        }
    }
}
</script>

<style scoped>
.cost-header {
    align-items: center;
    justify-content: center;
}

.tabs-container {
    display: flex;
    align-items: center;

    min-width: 300px;
}

.tariff-card {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    border-radius: 12px;
    background: var(--qrw-background-base-secondary);
}

.card-row {
    display: flex;
    align-items: center;
    column-gap: 16px;
}

.card-label {
    width: 200px;
    color: var(--qrw-content-base-tertiary);
}
</style>